export enum DiagramTabsInEditEnum {
  DETAILS,
  CHANGES,
  VERSIONS,
  CHANGELOG,
  SWIMLANES
}
